import
{
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input, OnChanges,
  OnDestroy,
  Output,
  Renderer2,
  ViewChild
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Filter } from '@idto';
import { SearchRepositoryService } from '@service/search-repository/search-repository.service';
import { Subject } from 'rxjs';
import { ParsedSearchResult } from '../../../../model/ParsedSearchResult.model';

@Component({
    selector: 'app-active-filters',
    templateUrl: './active-filters.component.html',
    styleUrls: ['./active-filters.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ActiveFiltersComponent implements OnChanges
{

  private _searchResult: ParsedSearchResult;
  @Input() public set searchResult(value: ParsedSearchResult)
  {
    this._searchResult = value;
    this.checkSearchQuery = this._searchResult && this._searchResult.searchQuery && this._searchResult.searchQuery.query &&
      this._searchResult.searchQuery.query.length > 0 &&
      this._searchResult.searchQuery.query !== '*';
  }
  public get searchResult(): ParsedSearchResult
  {
    return this._searchResult;
  }
  @Output() private readonly changed: EventEmitter<any> = new EventEmitter();
  @ViewChild('container') private container: ElementRef;
  private blinkInterval: any;
  public isRecent: boolean;
  @Input() public sidePanel: boolean;
  public checkSearchQuery: boolean

  constructor(private searchRepoService: SearchRepositoryService, private changeDet: ChangeDetectorRef, private renderer2: Renderer2, private route: ActivatedRoute)
  {
  }

  private cachedLink: any;

  public change(filter: any): void
  {
    this.changed.emit(filter);
  }

  public ngOnChanges(): void
  {
    if (this.route.snapshot.queryParamMap.get('type') == 'recent')
    {
      this.isRecent = true;
    }
  }

  public unselectAll(): void
  {
    this.changed.emit({ filter: null });
  }

  public clearSti(): boolean
  {
    this.changed.emit({ resetSti: true });
    return false;
  }
  public clearQuery(): boolean
  {
    if (this.searchResult.activeFilters.length > 0)
    {
      this.searchRepoService.updateQuery('');
    }

    this.changed.emit({ resetQuery: true });

    this.searchResult.searchQuery.query = '';
    return false;
  }

  public trackByIndex(index, item): number
  {
    return index;
  }

  public blinkFilters(): void
  {
    this.renderer2.addClass(this.container.nativeElement, 'blinking');
    this.changeDet.detectChanges();
    clearTimeout(this.blinkInterval);
    this.blinkInterval = setTimeout(() =>
    {
      this.renderer2.removeClass(this.container.nativeElement, 'blinking');
      this.changeDet.detectChanges();
    }, 1500);

  }
}
